import axios from 'axios'
import { BUILDER_CONTENT_API_BASE_URL } from './constants'

export const BuilderContentApiClient = axios.create({
  baseURL: BUILDER_CONTENT_API_BASE_URL,
})
